interface IconProps {
  width?: string;
  height?: string;
  stroke?: string;
  strokeWidth?: string;
}
const AddIcon = ({ width, height, stroke, strokeWidth }: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width ?? '26'}
      height={height ?? '26'}
      viewBox="0 0 26 26"
      fill="none"
    >
      <path
        d="M13 23.5V2.5M2.5 13H23.5"
        stroke={stroke ?? '#9BA3AE'}
        strokeWidth={strokeWidth ?? '4'}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default AddIcon;
